import React from 'react'
import './popup.css'
import {MdCancel} from 'react-icons/md'

function Popup({ showPopup, setShowPopup }) {

    if (!showPopup) {
        return null;
    }
    return (
        <ul className='popup-menu'>
            <li className='cancel-popup' onClick={() => setShowPopup(false)}><MdCancel /></li>            
            <li><a href="#About" onClick={() => setShowPopup(false)}>About</a></li>
            <li><a href="#Services" onClick={() => setShowPopup(false)}>Services</a></li>
            <li><a href="#clients" onClick={() => setShowPopup(false)}>Clients</a></li>
            <li><a href="#Contact" onClick={() => setShowPopup(false)}>Contact</a></li>
        </ul>
    )
}

export default Popup